import type { FeatureFlagName } from '@trackly/shared';
import { useGetFeatureFlagsQuery } from '../services/FeatureFlagService';

/**
 * Whether a server-side feature flag is on (ADR 0010). Fails closed: false while loading, on
 * error, and when the flag is absent or not exactly `true`.
 */
export function useFeatureFlag(name: FeatureFlagName): boolean {
  const { data, isError } = useGetFeatureFlagsQuery();
  return !isError && data?.flags?.[name] === true;
}
